<script lang="ts" setup>
import Terms from '~/components/pages/terms.vue';
import TermsOfUsePageContent from '~/utils/contents/pages/TermsOfUsePage';

definePageMeta({
  layout: 'empty',
  name: 'terms',
  auth: false,
});

useHead({
  title: TermsOfUsePageContent.seo.title,
});
</script>

<template>
  <div class="terms-of-use-page py-10">
    <Terms />
  </div>
</template>

<style lang="scss" scoped>
.terms-of-use-page {
  &__content {
    padding: $spacing-5xl;
  }
}
</style>
